export default class SourceLayer {
    id;
    imageId;
    source;
    layer;
    onClick;
    constructor(id, imageId, features) {
        this.id = id;
        this.imageId = imageId;
        this.source = {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': features.map((feature) => feature.getValue())
            }
        };
        this.layer = {
            'id': id,
            'type': 'symbol',
            'source': id,
            'layout': {
                'icon-image': imageId,
                'icon-rotate': ['get', 'rotation'],
                'icon-allow-overlap': true,
            }
        };
        this.onClick = () => { };
    }
    getId() {
        return this.id;
    }
    getImageId() {
        return this.imageId;
    }
    getSource() {
        return this.source;
    }
    getLayer() {
        return this.layer;
    }
    setOnClick(onClick) {
        this.onClick = onClick;
    }
    getOnClick() {
        return this.onClick;
    }
}
